import { Outlet } from 'react-router-dom';

const BuildingsOutlet = () => {
  return <Outlet />;
};

export default BuildingsOutlet;
